/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=0a8f80f8&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=0a8f80f8&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/yunxiaobao-test/prod-huodada-com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a8f80f8"]])

export default __exports__